import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Настройка axios
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3000'

// Отчёт посещаемости (server/visits): браузер выполнил JS — значит, страницу
// открыл человек, а не сканер, который только скачал HTML. Адрес берём до
// старта роутера, пока он не заменил его каноническим.
try {
  const body = JSON.stringify({ path: location.pathname + location.search, referrer: document.referrer })
  navigator.sendBeacon(`${axios.defaults.baseURL}/api/visit/js`, new Blob([body], { type: 'application/json' }))
} catch (e) {
  // статистика не должна ломать сайт
}

const app = createApp(App)

app.config.globalProperties.$http = axios
app.use(router)
app.mount('#app')
